import breakpoints from '../../constants/breakpoints'
import theme from '../../theme'

const breakpointMd = '@media (min-width: 768px)'
const breakpointLg = `@media (min-width: ${breakpoints.lg})`

export const formControlLabel = {
  alignItems: 'center',
  backgroundColor: 'white',
  border: 'solid',
  borderColor: theme.lightGrey,
  borderRadius: 0.5,
  borderWidth: 1,
  boxShadow: 'none',
  color: theme.darkGrey,
  display: 'flex',
  flexDirection: 'row',
  fontFamily: theme.primaryFont,
  height: '100%',
  lineHeight: '1.2',
  margin: 0,
  padding: '15px',
  textDecoration: 'none',
  textTransform: 'none',
  transition: 'all 0.3s ease',
  width: '100%',
  [breakpointMd]: {
    flexDirection: 'column'
  },
  '&:hover': {
    boxShadow: '0 2px 10px 0 rgba(30, 30, 30, 0.4)',
    backgroundColor: theme.blue,
    borderColor: theme.blue,
    color: 'white',
    '& svg': {
      fill: 'white'
    }
  },
  '&:focus-within': {
    outline: '5px auto #005fcc',
    outlineOffset: '5px'
  },
  '&>span': {
    fontSize: '1rem',
    fontFamily: theme.primaryFont,
    [breakpointLg]: {
      fontSize: '1.5rem'
    }
  }
}

export const radioGroup = {
  [breakpointMd]: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap'
  }
}

export const formControl = {
  marginTop: '60px'
}

export const typography = {
  body1: {
    fontSize: '1.5rem',
    fontFamily: theme.primaryFont
  }
}
